import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from "./App";
import { BrowserRouter as Router } from 'react-router-dom';
import {HeroUIProvider} from "@heroui/react";
import { Authenticator } from '@aws-amplify/ui-react'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HeroUIProvider>
      <Authenticator.Provider>
        <Router>
          <App className=""/>
        </Router>
      </Authenticator.Provider>
    </HeroUIProvider>
);

